<script lang="ts">
import { defineComponent, h, ref, toRefs, unref } from 'vue';

import { classNames } from '@components/utils';

import {
  makeDirectionProps,
  makeGroupProps,
  makeTagProps,
  makeThemeProps,
  provideTheme,
  useDirection,
  useGroup,
  useRender
} from '../../composable';

import { CdsCardGroupSymbol, useProvideCard } from './context';

export const componentName = 'CdsCardGroup';
export default defineComponent({
  name: componentName,
  props: {
    ...makeGroupProps(),
    ...makeDirectionProps(),
    ...makeTagProps(),
    ...makeThemeProps()
  },
  emits: {
    'update:modelValue': (value: any) => true
  },
  setup(props, { slots }) {
    const group = useGroup(props, CdsCardGroupSymbol);
    const { themeClasses } = provideTheme(props);
    const { directionClasses } = useDirection(props, componentName);
    const { multiple } = toRefs(props);

    const rootRef = ref<HTMLElement>();

    useProvideCard({
      rootRef,
      multiple
    });

    useRender(() =>
      h(
        props.tag,
        {
          ref: rootRef,
          class: classNames('cds-card-group', unref(directionClasses), unref(themeClasses))
        },
        slots.default?.(group)
      )
    );

    return {};
  }
});
</script>
